<h1 mat-dialog-title>{{ 'Presence.Edit.DialogTitle' | translate }}</h1>

<mat-dialog-content>
    <input type="file" class="mb-4" (change)="onFileSelected($event)" accept=".ppt,.pptx" />

    <br />

    @if (!presencePowerPointFileData()) {
        <p>{{ 'Presence.Edit.NoPresenterPowerPoint' | translate }}</p>
    } @else {
        <a mat-stroked-button download="GV Praesenz.pptx" [href]="presencePowerPointFileDataHref()">
            {{ 'Presence.Edit.DownloadPowerPoint' | translate }}
        </a>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close>
        {{ 'General.Cancel' | translate }}
    </button>

    <button mat-flat-button (click)="saveSettings()" [disabled]="isSaving()">
        <mat-icon>save</mat-icon>
        {{ 'General.Save' | translate }}
    </button>

    @if (isSaving()) {
        <mat-spinner class="mx-4" [diameter]="24" />
    }
</mat-dialog-actions>
